import { Component } from 'react';

/**
 * Barrera de errores: que un fallo de una pantalla no deje TODO en negro.
 *
 * EL PROBLEMA, REPORTADO EL 11-AGO-2026
 * Al volver de Oportunidades a Conversaciones la pantalla se quedaba negra y
 * habia que refrescar el navegador para recuperarla.
 *
 * LA CAUSA DE FONDO: no habia ninguna barrera de errores en toda la aplicacion.
 * En React, si un componente falla al dibujarse y nadie lo atrapa, se desmonta
 * el arbol ENTERO — y lo que queda es una pantalla en blanco o negra. No importa
 * cual sea el fallo: el resultado siempre es el mismo y el usuario no puede
 * hacer nada salvo recargar.
 *
 * QUE HACE ESTO
 * Atrapa el fallo, deja el menu en pie, y le enseña al usuario un mensaje con
 * dos botones: reintentar (sin recargar) o ir al panel. Ademas guarda el error
 * para que se pueda saber QUE fallo, que hasta ahora no se sabia.
 *
 * NO ARREGLA la causa del fallo concreto: convierte una pantalla muerta en algo
 * de lo que se puede salir, y deja la pista para arreglar la causa.
 */
export default class PantallaSegura extends Component {
  constructor(props) {
    super(props);
    this.state = { fallo: null };
  }

  static getDerivedStateFromError(error) {
    return { fallo: error };
  }

  componentDidCatch(error, info) {
    // Queda en la consola del navegador para poder diagnosticarlo.
    // eslint-disable-next-line no-console
    console.error('[PantallaSegura] la pantalla fallo:', error, info?.componentStack);
    try {
      const previos = JSON.parse(sessionStorage.getItem('fallos_pantalla') || '[]');
      previos.push({
        cuando: new Date().toISOString(),
        donde: window.location.pathname,
        mensaje: String(error?.message || error).slice(0, 300),
      });
      sessionStorage.setItem('fallos_pantalla', JSON.stringify(previos.slice(-10)));
    } catch (e) {
      /* si ni esto se puede, no pasa nada */
    }
  }

  componentDidUpdate(prevProps) {
    // Al cambiar de pantalla, se limpia el fallo anterior: si el usuario navega
    // a otro sitio no tiene por que seguir viendo el error del anterior.
    if (this.state.fallo && prevProps.clave !== this.props.clave) {
      this.setState({ fallo: null });
    }
  }

  render() {
    if (!this.state.fallo) return this.props.children;

    return (
      <div className="flex flex-col items-center justify-center py-20 text-center gap-4">
        <p className="text-lg font-semibold text-white">Esta pantalla no se pudo mostrar</p>
        <p className="text-sm text-muted-foreground max-w-md">
          Hubo un problema al dibujarla. El resto del sistema sigue funcionando:
          puedes reintentar o irte a otra pantalla desde el menu.
        </p>
        <div className="flex gap-3">
          <button
            onClick={() => this.setState({ fallo: null })}
            className="px-4 py-2 rounded-lg bg-white/10 border border-white/20 text-white text-sm hover:bg-white/20"
            data-testid="reintentar-pantalla"
          >
            Reintentar
          </button>
          <button
            onClick={() => { window.location.href = '/dashboard'; }}
            className="px-4 py-2 rounded-lg bg-white/5 border border-white/10 text-muted-foreground text-sm hover:text-white"
          >
            Ir al panel
          </button>
        </div>
        <p className="text-[11px] text-muted-foreground/60 max-w-lg break-words">
          {String(this.state.fallo?.message || this.state.fallo).slice(0, 200)}
        </p>
      </div>
    );
  }
}
